angular.module('impactx.supplierbaskettemplate').controller('SupplierBasketTemplateClientSelectionCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'confirmLabel',
    'abortLabel',
    '$context',
    'themeFactory',
    '$redirect',
    '$sce',
    SupplierBasketTemplateClientSelectionCtrl]);

function SupplierBasketTemplateClientSelectionCtrl($scope, dataGen, $mdDialog, confirmLabel, abortLabel, $context, themeFactory, $redirect, $sce) {

    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.theme = themeFactory.getTheme();
    $scope.$sce = $sce;
    $scope.isSupplier = $context.showSupplierBasket.value;

    dataGen.getData($scope, {}, "/supplierbaskettemplate/clientselection");

    this.cancel = function() {
        $mdDialog.cancel();
    };
    this.answer = function() {
        $mdDialog.hide();
        $redirect.redirectTo(null, "/supplierbasket/0/" + $scope.data.selected.id + ($scope.data.comPopup ? ("/" + $scope.data.comPopup.selected.id) : ""));
    };

    this.getInformationText = function(selectedUser, selectedCom) {
        var newScope = {};

        if(selectedUser && selectedUser.id > 0) {
            var paramObject = {
                userId: selectedUser.id,
                comId: 0
            };
            if(selectedCom && selectedCom.id > 0){
                paramObject.comId = selectedCom.id;
            }
            $scope.requestInProgress = true;
            dataGen.getData(newScope, paramObject, "/supplierbaskettemplate/clientinformationtext", null, true).then(function() {
                if(newScope.data) {
                    $scope.data.informationText = newScope.data.informationText;
                    if (newScope.data.comPopup) {
                        $scope.data.comPopup = newScope.data.comPopup;
                    }
                }
                $scope.requestInProgress = false;
            });
        }
    }
}